import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export const useTranslations = () => {
  const { t, i18n } = useTranslation();

  // Fonction pour changer de langue avec vérification
  const changeLanguage = async (lng) => {
    try {
      await i18n.changeLanguage(lng);
      // Forcer le re-render en cas de problème
      window.dispatchEvent(new Event('languageChanged'));
    } catch (error) {
      console.error('Erreur lors du changement de langue:', error);
    }
  };

  // Fonction pour obtenir une traduction avec fallback
  const getSafeTranslation = (key, options = {}) => {
    const translation = t(key, options);
    
    // Si la traduction retourne la clé, c'est qu'elle n'existe pas
    if (translation === key) {
      console.warn(`🔍 Traduction manquante pour: ${key} (langue: ${i18n.language})`);
      return options.fallback || key;
    }
    
    return translation;
  };

  // Vérifier si la langue est bien chargée
  const isLanguageReady = i18n.isInitialized && i18n.language;

  useEffect(() => {
    // S'assurer que la langue est bien chargée
    if (!isLanguageReady && i18n.isInitialized) {
      console.warn('🔄 Langue non prête, rechargement...', i18n.language);
    }
  }, [i18n.language, isLanguageReady]);

  return {
    t: getSafeTranslation,
    i18n,
    changeLanguage,
    isLanguageReady,
    currentLanguage: i18n.language
  };
};

export default useTranslations; 